import React from "react";
import { map } from "lodash";

import { fetchGet } from "../../api/fetch";

import Grid from "@material-ui/core/Grid";

import ScrollableTable from "../Common/Table/ScrollableTable";

import { levels } from "../../constants/companies";

import CompanyDevicesRow from "./CompanyDevicesRow";

const columns = [
  {
    name: "profiles_name",
    minWidth: 300,
  },
  {
    name: "profiles_type",
    minWidth: 200,
  },
  {
    name: "companies_company",
    minWidth: 150,
  },
  {
    name: "companies_site",
    minWidth: 150,
  },
  {
    name: "companies_zone",
    minWidth: 250,
  },
];

const CompanyDevices = (props) => {
  const { companyId, companyName, siteId, language } = props;
  const [devices, setDevices] = React.useState();
  const [isFetching, setIsFetching] = React.useState(false);

  const level = siteId ? levels.site : levels.company;

  React.useEffect(() => {
    fetchDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, siteId]);

  const fetchDevices = async () => {
    setIsFetching(true);
    try {
      let devices = [];
      if (level === levels.company) {
        devices = await fetchGet(`companies/${companyId}/devices?active=true`);
      } else if (level === levels.site) {
        devices = await fetchGet(
          `companies/${companyId}/sites/${siteId}/devices?active=true`
        );
      }
      setDevices(devices);
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
  };

  return (
    <Grid item style={{ overflow: "auto", maxWidth: "1300px" }}>
      <ScrollableTable
        columns={columns}
        hasMore={false}
        isFetching={isFetching}
        stickyHeader
      >
        {map(devices, (item, index) => (
          <CompanyDevicesRow
            key={index}
            item={item}
            language={language}
            levelId={0}
            companyName={companyName}
          />
        ))}
      </ScrollableTable>
    </Grid>
  );
};

export default CompanyDevices;
